import React from 'react';
import moment from 'moment';
import { TIMELINE_DIMENSION, ALL_DISPLAY_NAMES } from '@components/session-timeline/utils/constants';
import CustomEventCell from './components/CustomEventCell';
import TooltipCell from './components/TooltipCell';

interface ITSProps {
  ts: number | number[];
}

const TimeStamp: React.FC<ITSProps> = ({ ts }) => {
  if (Array.isArray(ts)) {
    return (
      <span>
        <strong>{moment(ts[0]).format('HH:mm')}</strong>
        {moment(ts[0]).format(':ss.SSS')}
        -
        <strong>{moment(ts[1]).format('HH:mm')}</strong>
        {moment(ts[1]).format(':ss.SSS')}
      </span>
    );
  }
  return (
    <span>
      <strong>{moment(ts).format('HH:mm')}</strong>
      {moment(ts).format(':ss.SSS')}
    </span>
  );
};

/* eslint-disable import/prefer-default-export */
export const defaultColumns = {
  [TIMELINE_DIMENSION.Error]: [{
    key: 'errorMessage',
    dataKey: 'errorMessage',
    align: 'left',
    title: ALL_DISPLAY_NAMES[TIMELINE_DIMENSION.Error],
    width: 350,
    cellRenderer: TooltipCell,
    resizable: true,
  }, {
    key: 'type',
    dataKey: 'type',
    align: 'left',
    title: 'Type',
    width: 150,
    cellRenderer: ({ cellData }) => ALL_DISPLAY_NAMES[cellData] || cellData,
    resizable: true,
  }, {
    key: 'time',
    dataKey: 'time',
    align: 'center',
    title: 'Timestamp',
    width: 150,
    cellRenderer: ({ cellData }) => <TimeStamp ts={cellData} />,
    resizable: true,
  }, {
    key: 'errorType',
    dataKey: 'errorType',
    align: 'left',
    title: 'Impact',
    width: 100,
  }],
  [TIMELINE_DIMENSION.Bitrate]: [{
    key: 'value',
    dataKey: 'value',
    align: 'left',
    title: ALL_DISPLAY_NAMES[TIMELINE_DIMENSION.Bitrate],
    width: 200,
    resizable: true,
  }, {
    key: 'time',
    dataKey: 'time',
    align: 'center',
    title: 'Occurrence',
    flexGrow: 1,
    cellRenderer: ({ cellData }) => <TimeStamp ts={cellData} />,
  }],
  [TIMELINE_DIMENSION.CustomEvent]: [{
    key: 'name',
    dataKey: 'name',
    align: 'left',
    title: 'Event Name',
    width: 200,
    cellRenderer: ({ cellData }) => ALL_DISPLAY_NAMES[cellData] || cellData,
    resizable: true,
  }, {
    key: 'attributes',
    dataKey: 'attributes',
    align: 'left',
    title: 'Attributes',
    width: 250,
    cellRenderer: CustomEventCell,
    resizable: true,
  }, {
    key: 'states',
    dataKey: 'states',
    align: 'left',
    title: 'States',
    width: 250,
    cellRenderer: CustomEventCell,
    resizable: true,
  }, {
    key: 'measurement',
    dataKey: 'measurement',
    align: 'left',
    title: 'Measurement',
    width: 250,
    cellRenderer: CustomEventCell,
    resizable: true,
  }, {
    key: 'time',
    dataKey: 'time',
    align: 'center',
    title: 'Timestamp',
    width: 120,
    cellRenderer: ({ cellData }) => <TimeStamp ts={cellData} />,
  }],
};
